import React, {Component} from "react";
import {AsyncTypeahead} from 'react-bootstrap-typeahead'
import {Query} from 'react-apollo'
import {gql} from 'apollo-boost'

const QUERY = gql`
query search_projects($query: String) {
  search_projects(query: $query) {
    project_id_prefix
    project_id
    name
    description
    project_activity_budgets {
      id
      project_activity_type_id
      project_activity_type{
        description
      }
      description
      address{
        address_id
        name
        full_address
      }
      stage
      breakdown {
        id
        description
        amount
      }
      budget_total
      budget_used
      supplier_total
    }
    project_clients {
      client {
        client_id
        name
      }
    }
  }
}`

export default class Search extends Component{

    state = {
        isLoading: false,
        options: [],
        query: ''
    }

    renderMenuItemChildren = (option) => {
        return (
            <div>{option.project_id}<br/>
                <small>{option.name}</small><br/>
                {(option.project_clients && option.project_clients.length > 0) && <small>{option.project_clients.map(({client}) => client.name).join(', ')}</small>}
            </div>)
    }


    render(){
        return (<Query query={QUERY} variables={{query: this.state.query}}>
            {({ loading, data: { search_projects } }) => {
                return (<AsyncTypeahead
                    {...this.props}
                    bsSize="sm"
                    labelKey={(value) => `${value.project_id} - ${value.name}`}
                    ref={(ref) => {
                        if(this.props.reference) this.props.reference(ref)
                    }}
                    filterBy={['project_id', 'name']}
                    minLength={0}
                    onSearch={(query) => {
                        this.setState({query})
                        this.props.onSearch(query)
                    }}
                    defaultSelected={(this.props.selectedProject) ? [this.props.selectedProject] : []}
                    onChange={(selected) => this.props.onChange(selected)}
                    isLoading={loading}
                    options={search_projects}
                    placeholder={this.props.placeholder}
                    renderMenuItemChildren={this.renderMenuItemChildren}
                />)
            }}

        </Query>)
    }
}